import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'gettingStarted/appStorage';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const APP_STORAGE_FETCH_GROUPS = createApiNamespacedConstants('APP_STORAGE_FETCH_GROUPS');
